import Api from '@/api/api.js'

export default {
    
    /**
     * Route pour recuperer les attributs possible  
     */
    typeAttributs () {
        const promise = Api().get('/type_attributs')
        return promise.then((response) => response.data)
    },

    /**
     * Enregistrer un type d'article
     * @param object data 
     */
    saveTypeArticle (data) {
        const promise = Api().post('/type_articles', data)
        return promise.then((response) => response)
    },

    editTypeArticle (id,data) {
        const promise = Api().put('/type_articles/'+id, data) 
        return promise.then((response) => response)
    },

    editTypeArticleAttribut (data) {
        const promise = Api().put('/type_articles/save/occurence-attribut', data)         
        return promise.then((response) => response.data)
    },

    deleteTypeArticleAttribut (id) {
        const promise = Api().delete('/type_articles/attribut/'+id) 
        console.log(promise);
        return promise.then((response) => response.data)
    },

    typeArticles () {
        const promise = Api().get('/type_articles')
        return promise.then((response) => response.data)
    },

    getType (id) {
        const promise = Api().get('/type_articles/'+id)
        return promise.then((response) => response.data)
    },

    getTypeArticles (id) {
        const promise = Api().get('/type_articles/articles/'+id)
        return promise.then((response) => response.data)
    },

    

  }